"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var NotificationMetadataFilters = [{
  label: 'High priority',
  key: 'high_priority_only',
  ansQueryFormat: {
    field: 'metadata.priority',
    value: 'high',
    operator: 'EQ'
  }
}, {
  label: 'Unread',
  key: 'unread',
  ansQueryFormat: {
    field: 'state',
    value: 'NEW',
    operator: 'EQ'
  }
}];
var _default = NotificationMetadataFilters;
exports.default = _default;